import { Icon, IconVariants } from "@next-platform/client-common-spicy-ui";
import { useTranslation } from "@next-platform/client-common-core";
import { motion } from "framer-motion";
import React, { useState } from "react";

import { cn, CommandType } from "@/utils";

interface ICustomCommandRendererProps {
  children: React.ReactNode;
  role: CommandType;
  className?: string;
}

const getIcon = (isCommandCollapsed: boolean) => {
  return <Icon icon={isCommandCollapsed ? IconVariants.CHEVRON_DOWN : IconVariants.CHEVRON_UP} className="min-w-lg size-lg text-white ml-sm" />;
};

const CustomCommandRenderer = ({ children, role, className }: ICustomCommandRendererProps) => {
  const [isCommandCollapsed, setIsCommandCollapsed] = useState(true);
  const { t } = useTranslation();
  const commandRole = role;

  const handleDirectedCollapse = () => {
    setIsCommandCollapsed(!isCommandCollapsed);
  };

  const getLabel = () => {
    if (commandRole === CommandType.SEARCH) {
      return t("chat:chatBubble.commandBox.label.searched");
    } else {
      return t("chat:chatBubble.commandBox.label.directed");
    }
  };

  return (
    <div className="text-sm">
      <button
        className={cn("bg-transparent w-full cursor-pointer flex items-start transition-opacity text-white  opacity-[0.76]", className)}
        onClick={handleDirectedCollapse}
      >
        <p className="whitespace-nowrap overflow-hidden text-start font-roboto-mono flex">
          {getLabel()} {!isCommandCollapsed && getIcon(isCommandCollapsed)}
          <span className={cn("font-roboto-mono truncate", !isCommandCollapsed && "opacity-0")}>: {children}</span>
        </p>
        {isCommandCollapsed && getIcon(isCommandCollapsed)}
      </button>
      <motion.aside
        className="text-yellow-9 overflow-hidden font-roboto-mono"
        initial={false}
        animate={{
          height: isCommandCollapsed ? 0 : "auto",
          opacity: isCommandCollapsed ? 0 : 1,
          marginTop: isCommandCollapsed ? 0 : 4,
        }}
      >
        {children}
      </motion.aside>
    </div>
  );
};

export default CustomCommandRenderer;
